import React, { useState, useContext } from "react";
import { ToastContext } from "../context/toast";

const Props = ({
  defaultOption,
  dependencyClass,
  property,
  definition,
  options,
  flexItems,
  flexContainer: { fcHeight, fcWidth },
}) => {
  const [currentOption, setCurrentOption] = useState(defaultOption);
  const toastHandlerContext = useContext(ToastContext);

  const handleClick = (option) => {
    const { setVisible } = toastHandlerContext;

    setVisible(true);
    setCurrentOption(option);
    handleCopyCode(option);

    setTimeout(() => {
      setVisible(false);
    }, 3000);
  };

  const handleCopyCode = (option) => {
    let code = `.container{\n display: flex;\n ${property}: ${option};\n`;

    // for the moment we can use if, if we had more dependency classes we need a switch
    if (dependencyClass && dependencyClass === "wrap-item") {
      code += `flex-wrap: wrap;`;
    }

    code += `}`;

    // copy api call for copying to clipboard
    navigator.clipboard.writeText(code);
  };

  return (
    <div className="props-container">
      <div className="props-title" id={property || ""}>
        <h2>{property || ""}</h2>
        <p>{definition || ""}</p>
      </div>
      <div className="props-banner">
        <div className="props-controls">
          {options?.map((cssOption) => {
            return (
              <button
                className={`props-button ${
                  currentOption === cssOption && "active"
                }`}
                onClick={() => handleClick(cssOption)}
              >{`${property}: ${cssOption};`}</button>
            );
          })}
        </div>
        <div className="props-result">
          <div
            className={`flex-container ${dependencyClass || ""}`}
            style={{
              [property]: currentOption,
              height: fcHeight || "",
              width: fcWidth || "",
            }}
          >
            {flexItems?.map(({ itemWidth, itemHeight, label }) => {
              return (
                <div
                  className="flex-item"
                  style={{ width: itemWidth || "", height: itemHeight || "" }}
                >
                  <b>{label}</b>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Props;
